
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"45","height":"45"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M35.625 15H9.375a5.617 5.617 0 0 0-5.625 5.625v11.25h7.5v7.5h22.5v-7.5h7.5v-11.25A5.617 5.617 0 0 0 35.625 15zM30 35.625H15V26.25h15zM35.625 22.5a1.875 1.875 0 1 1 1.875-1.875 1.881 1.881 0 0 1-1.875 1.875zM33.75 5.625h-22.5v7.5h22.5z"}}),_c('path',{attrs:{"d":"M0 0h45v45H0z","fill":"none"}})])
          )
        }
      }
    